
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import { TrendingUp, TrendingDown, Bell } from 'lucide-react';
import logo from './images/logo.jpeg';
import PriceAlertPopup from './pages/alert_notification_pop_up.js'
import { useNavigate } from 'react-router-dom';
import SearchComponent from './pages/search_stock.js';


// Price Alert Popup Component
const ScreenerIcon = ({ url }) => (
  <svg
    onClick={() => window.open(url, "_blank")}
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{
      cursor: "pointer",

      color: "#6c757d",
      transition: "color 0.3s ease",
    }}
  >
    <path d="M15 3h6v6" />
    <path d="M10 14 21 3" />
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
  </svg>
);









const Header = () => {
  const location = useLocation();
  const navigate = useNavigate(); // Add this import: import { useNavigate } from 'react-router-dom';
  const [activeHeader, setActiveHeader] = useState(null);
  const [activeSubheader, setActiveSubheader] = useState(null);
  const [showAlertPopup, setShowAlertPopup] = useState(false);

  const callHeaderAPI = async () => {
    try {
      const response = await fetch('https://live1.finstrats.com/intrvl_hl_data');
      console.log('Header API Response:', response.data);
    } catch (error) {
      console.error('Error calling Header API:', error);
    }
  };

  useEffect(() => {
    callHeaderAPI();
  }, []);

  const mainNavItems = [
    {
      name: 'Heat Map',
      to: '/sector_heatmap',
      subheader: [
        { name: 'Industry', to: '/sector_heatmap' },
        { name: 'Industry Rank', to: '/sector_rank_change' },
        { name: 'Stock Rank', to: '/stock_rank_change' },
      ],
    },
    {
      name: 'Stocks',
      to: '/',
      subheader: [
        { name: 'Top Gainers Losers', to: '/' },
        { name: 'G&L Details', to: '/gainersdetails' },
        { name: '52Week High', to: '/weekhigh_stock' },
        { name: '52W Drawdown', to: '/drawdown_changes' },
        // { name: 'Result Impact', to: '/strategies_res' },


        { name: 'Approach High', to: '/strategies_duration' },
        // { name: 'Notifications', to: '/notification' },
        { name: 'watchlist', to: '/watchlist' },
        { name: 'Candle Pattern', to: '/candle_pattern' },
        { name: 'HighOI', to: '/highoi' },
        { name: 'Vol Blast', to: '/vol_blast' },
        { name: 'Pre/Market', to: '/premarket_top_gl' },
        { name: 'Result', to: '/result_analysis' },



      ],
    },
    {
      name: 'F&O',
      to: '/f_o_dashboard',
      subheader: [
        { name: 'F&O Stocks', to: '/f_o_dashboard' },
        { name: 'Stock Details', to: '/f_o_listdata' },
        { name: 'Industry', to: '/f_o_industry_score' },
        { name: 'Blast', to: '/highvolume' },
        { name: '', to: '/vol_blast' },
      ],
    },
    // { name: 'Index', 
    //   to: '/index' 
    // },
    {
      name: 'Index', to: '/options',

    },
    {
      name: 'Options', to: '/stock_timeseries', // Changed this to the default route
      subheader: [
        // {name:'Dashboard', to: '/stock_timeseries'},
        { name: 'Dashboard', to: '/trendingstock' },
        { name: 'Options Details', to: '/stock_options' },
        { name: 'Stock Rank', to: '/stock_rank' },
        { name: 'Rank Change', to: '/rank_change' },
        { name: 'Momentum', to: '/momentum_stock' },
        { name: 'Vol Blast', to: '/volume_blast_intraday' },
        { name: 'Trade Log', to: '/tradelog' },



      ],
    },


    {
      name: 'Strategy',
      to: '/f_o_watchlist'
    },
    {
      name: 'Portfolio',
      to: '/portfolio',
      subheader: [
        { name: 'Dashboard', to: '/portfolio' },
        { name: 'Holdings', to: '/portfolio/holdings' },
        { name: 'Positions', to: '/portfolio/positions' },
        { name: 'Orders', to: '/portfolio/orders' },
        { name: 'Basket', to: '/portfolio/basket' },
        { name: 'ATO', to: '/portfolio/ato' }
      ]
    },
    // { name: 'Pullback', 
    //   to: '/pullback' 
    // },

    // {
    //   name: 'Alert',
    //   to: '/alert_stock',


    {
      name: 'Query',
      to: '/filter-with-query',
    },
  ];

  const rightNavItems = [
    { name: 'High Volume', to: '/highvolume' },
    { name: 'Flat Candle', to: '/flat_candle' },
    { name: 'BTST', to: '/btst-data' },
    { name: 'Indices', to: '/index' },
  ];

  // Update active states based on current route
  useEffect(() => {
    const currentPath = location.pathname;

    // if (currentPath === '/') {
    //   setActiveHeader(null);
    //   setActiveSubheader(null);
    //   return;
    // }




    for (const item of mainNavItems) {
      if (item.subheader) {
        const matchingSubheader = item.subheader.find(sub => sub.to === currentPath);
        if (matchingSubheader) {
          setActiveHeader(item.name);
          setActiveSubheader(matchingSubheader.name);
          return;
        }
      }
      // Check main header path
      if (item.to === currentPath) {
        setActiveHeader(item.name);
        setActiveSubheader(null);
        return;
      }
    }
  }, [location.pathname]);

  const handleHeaderClick = (event, headerName, hasSubheader, itemTo) => {
    if (hasSubheader) {
      event.preventDefault();

      // Special case for Options - navigate to default page and show subheader
      if (headerName === 'Options') {
        navigate('/trendingstock');
        setActiveHeader(headerName);
        setActiveSubheader('Dashboard'); // Set the default active subheader
      }
      else if (headerName === 'Stocks') {
        navigate('/');
        setActiveHeader(headerName);
        setActiveSubheader('Top Gainers Losers'); // Set the default active subheader
      }
      else if (headerName === 'Portfolio') {
        navigate('/portfolio');
        setActiveHeader(headerName);
        setActiveSubheader('Dashboard'); // Set the default active subheader
      }
      else if (headerName === 'Heat Map') {
        navigate('/sector_heatmap');
        setActiveHeader(headerName);
        setActiveSubheader('Industry');
      }
      else {
        // For other headers with subheaders, just toggle the dropdown
        setActiveHeader(headerName === activeHeader ? null : headerName);
      }
    }
  };

  // Style for notification bell
  const notificationButtonStyle = {
    marginLeft: 'auto',

    backgroundColor: 'floralwhite',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: '8px',
    marginRight: '0%',
    borderRadius: '50%',
    transition: 'background-color 0.2s'
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link
          to="/card"
          className="logo-link"
          onClick={() => {
            setActiveHeader(null);
            setActiveSubheader(null);
          }}
        >
          <img src={logo} alt="Logo" className="header-logo" />
        </Link>

        <nav className="main-nav">
          <ul className="nav-list">
            {mainNavItems.map((item) => (
              <li
                key={item.name}
                className={`nav-item ${activeHeader === item.name ? 'active' : ''}`}
              >
                <Link
                  to={item.to}
                  className={`nav-link ${activeHeader === item.name ? 'active' : ''}`}
                  onClick={(e) => handleHeaderClick(e, item.name, !!item.subheader, item.to)}
                >
                  {item.name}
                  <span className="link-underline"></span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <SearchComponent />
        {/* Notification bell button */}
        <button
          style={notificationButtonStyle}
          onClick={() => setShowAlertPopup(true)}
          title="Create Price Alert"
        >
          <Bell size={22} color="#333" />
        </button>

      </div>

      {activeHeader && (
        <div className="subheader-container">
          <ul className="subheader-list">
            {mainNavItems
              .find((item) => item.name === activeHeader)
              ?.subheader?.map((subItem) => (
                <li key={subItem.name} className="subheader-item">
                  <Link
                    to={subItem.to}
                    className={`subheader-link ${activeSubheader === subItem.name ? 'active' : ''
                      }`}
                  >
                    {subItem.name}
                  </Link>
                </li>
              ))}
          </ul>
        </div>

      )}
      {/* Price Alert Popup */}

      <PriceAlertPopup
        isOpen={showAlertPopup}
        onClose={() => setShowAlertPopup(false)}
      />
    </header>
  );
};

export default Header;
